import { render } from "./videoplayer.vue?vue&type=template&id=fa2c1b40"
import script from "./videoplayer.vue?vue&type=script&lang=js"
export * from "./videoplayer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__